
const menuStates = {
  isMainMenuOpen: false,
  activeSubmenu: null,
  scrollPosition: 0,
  observer: null
};


function airiosoft_custom_toggle_menu_mobile() {
  const menu = document.getElementById("airiosoft_main_navigation_wrapper_pop");
  const gradients = document.getElementsByClassName("gradient");

  menuStates.scrollPosition = window.pageYOffset;

  if (!menuStates.isMainMenuOpen) {

    menu.classList.add("active");
    Array.from(gradients).forEach(el => el.classList.add("active"));
    menuStates.isMainMenuOpen = true;


    requestAnimationFrame(() => {
      menu.style.maxHeight = `100vh`;
      initScrollObserver();
    });
  } else { 
 
  menu.classList.remove("active");
  Array.from(gradients).forEach(el => el.classList.remove("active"));

  
  menu.style.maxHeight = ''; 
  menuStates.isMainMenuOpen = false;
  menuStates.activeSubmenu = null;
  destroyScrollObserver();
}

  window.requestAnimationFrame(() => {
    window.scrollTo(0, menuStates.scrollPosition);
  });
}

const mobileMenuButtons = document.getElementsByClassName("airiosoft_mobile_naviagtion_dropbox_button_container");

Array.from(mobileMenuButtons).forEach(button => {
  button.addEventListener("click", function(e) {
    e.stopPropagation();
    const currentPanel = this.nextElementSibling;
    const isSameMenu = menuStates.activeSubmenu === currentPanel;

    menuStates.scrollPosition = window.pageYOffset;

    if (menuStates.activeSubmenu && menuStates.activeSubmenu !== currentPanel) {
      closeSubmenu(menuStates.activeSubmenu, () => {
        if (!isSameMenu) toggleSubmenu(this, currentPanel);
      });
    } else {
      toggleSubmenu(this, currentPanel);
    }

    const parentContainer = this.closest('.airiosoft_mobile_naviagtion_dropbox_wrapper, .airiosoft_mobile_naviagtion_store_selector_container');
    if (parentContainer) {
      Array.from(parentContainer.parentNode.children).forEach(sibling => {
        if (sibling !== parentContainer) {
          closeSiblingSubmenus(sibling);
        }
      });
    }
  });
});

function toggleSubmenu(button, panel) {
  if (panel.classList.contains("active")) {
    closeSubmenu(panel);
  } else {
    panel.style.display = 'block';
    const targetHeight = panel.scrollHeight;
    panel.style.maxHeight = '0';

    void panel.offsetHeight;

    requestAnimationFrame(() => {
      panel.style.maxHeight = `${targetHeight}px`;
      panel.classList.add("active");
      button.classList.add("active");
      menuStates.activeSubmenu = panel;
    });
  }
}

function closeSubmenu(panel, callback) {
  const button = panel.previousElementSibling;
  
  panel.classList.add('disable-animation');
  panel.style.maxHeight = '0';

  panel.classList.remove("active");
  if (button) button.classList.remove("active");  // 关键修复点
  requestAnimationFrame(() => {
    panel.style.display = 'none';
    panel.style.maxHeight = '';
    panel.classList.remove('disable-animation');

    if (menuStates.activeSubmenu === panel) {
      menuStates.activeSubmenu = null;
    }
    if (callback) callback();
  });
}


function closeSiblingSubmenus(element) {
  if (element.matches('.airiosoft_mobile_naviagtion_dropbox_wrapper, .airiosoft_mobile_naviagtion_store_selector_container')) {
    Array.from(element.children).forEach(child => {
      if (child.matches('.airiosoft_mobile_naviagtion_dropbox_button_container, .airiosoft_mobile_naviagtion_dropbox_panel_container')) {
        child.classList.remove("active");
        const panel = child.nextElementSibling;
        if (panel) {
          panel.style.maxHeight = '';
          panel.style.display = '';
        }
      }
    });
  }
}

function initScrollObserver() {
  menuStates.observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && menuStates.isMainMenuOpen) {
        airiosoft_custom_toggle_menu_mobile();
      }
    });
  }, { threshold: 0.1 });

  menuStates.observer.observe(document.getElementById("airiosoft_main_navigation_wrapper_pop"));
}

function destroyScrollObserver() {
  if (menuStates.observer) {
    menuStates.observer.disconnect();
    menuStates.observer = null;
  }
}

document.addEventListener('click', (e) => {
  if (!e.target.closest('.airiosoft_mobile_naviagtion_dropbox_button_container') && 
      !e.target.closest('.airiosoft_mobile_naviagtion_dropbox_panel_container')) {
    if (menuStates.activeSubmenu) {
      closeSubmenu(menuStates.activeSubmenu);
    }
  }
});

window.addEventListener("beforeunload", () => {
  destroyScrollObserver();
});
